import React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

type WrappedNavLinkProps<S> = {
	to: string;
	children: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
} & NavLinkProps<S> &
	React.RefAttributes<HTMLAnchorElement>;

export default function WrappedNavLink<S>({
	to,
	children,
	onClick,
	...rest
}: WrappedNavLinkProps<S>) {
	const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
		if (
			!window.navigator.onLine ||
			location.pathname.includes("app-update")
		) {
			window.location.href = to;
		}
		if (onClick) {
			onClick(event);
		}
	};

	return (
		<NavLink to={to} onClick={handleClick} {...rest}>
			{children}
		</NavLink>
	);
}
